<template>
    <v-container class="container" fluid>
        <v-data-table
            :headers="headers"
            :items="causes"
            item-key="BookedCauseID"
            :search="search"
            class="elevation-10 ml-2"
            dense
            loading="dataLoading"
            loading-text="Loading... Please wait"
            fixed-header
            height="650px"
        >
            <template v-slot:top>
                <v-toolbar dense dark color="secondary">
                    <v-spacer />
                    <v-toolbar-title class="white--text"
                        >Book Off Cause</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-title>
                    <v-text-field
                        v-model="search"
                        label="Search"
                        append-icon="mdi-magnify"
                        dense
                    >
                    </v-text-field>
                    <v-spacer />
                    <v-spacer />
                    <v-col cols="2">
                        <v-combobox
                            append-outer-icon="mdi-microsoft-excel"
                            @click:append-outer="report()"
                            v-model="type"
                            :items="TypeReport"
                            :item-text="'TypeReport'"
                            :item-value="'id'"
                            hide-details
                            dense
                            label="Select Type Report"
                        ></v-combobox>
                    </v-col>
                    <v-btn
                        class="ml-1"
                        fab
                        large
                        color="secondary"
                        icon
                        @click="openNew"
                        exact
                    >
                        <v-icon large>mdi-plus-circle</v-icon>
                    </v-btn>
                </v-card-title>
            </template>
            <template v-slot:item.Active="{ item }">
                <v-switch
                    v-model="item.Active"
                    class="mr-3"
                    color="secondary"
                    dense
                    style="margin-top: 0px;padding-top: 0px;"
                    hide-details
                    @change="changeState(item)"
                >
                </v-switch>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mx-3" @click="openEditDialog(item)"
                    >mdi-pencil</v-icon
                >
                <!-- <v-icon small @click="deleteItem(item)">mdi-delete</v-icon> -->
            </template>
        </v-data-table>

        <v-col cols="auto">
            <v-dialog
                transition="dialog-top-transition"
                v-model="$store.state.book.dialog"
                max-width="1000"
            >
                <template>
                    <v-card>
                        <v-toolbar color="secondary" dark
                            >Book Off Cause Form
                            <v-spacer></v-spacer>
                            <v-btn
                                icon
                                dark
                                @click="$store.state.book.dialog = false"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-container>
                            <noLoad
                                v-if="$store.state.book.dialog"
                                :id="Id"
                            ></noLoad>
                        </v-container>
                    </v-card>
                </template>
            </v-dialog>
        </v-col>
    </v-container>
</template>

<script>
import axios from 'axios';
import noLoad from './BookOffCauseForm.vue';
export default {
    components: {
        noLoad
    },
    data: function() {
        return {
            dialog: false,
            causes: [],
            type: [],
            TypeReport: [
                { text: 'BookedCause', TypeReport: 'Active', id: 1 },
                { text: 'BookedCause', TypeReport: 'Not active', id: 2 },
                { text: 'BookedCause', TypeReport: 'All', id: 3 }
            ],
            headers: [
                { text: 'ID', value: 'BookedCauseID', width: '8%' },
                {
                    text: 'Terminal Name',
                    value: 'BookedCauseDescription',
                    width: '20%'
                },
                { text: 'Active', value: 'Active', width: '10%' },
                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false,
                    width: '5%'
                }
            ],
            search: ''
        };
    },

    watch: {
        '$store.state.bannerType': function() {
            if (this.$store.state.bannerType == true) {
                this.loadCauses();
                this.$store.state.bannerType = false;
            }
        }
    },

    mounted() {
        this.loadCauses();
    },

    methods: {
        openEditDialog(itm) {
            this.Id = itm.BookedCauseID;
            console.log(this.Id);
            this.$store.state.book.dialog = true;
        },
        openNew() {
            this.Id = 0;
            this.$store.state.book.dialog = true;
        },
        loadCauses: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .get('bookedoff-cause')
                .then(response => {
                    this.causes = response.data;
                    console.log(this.causes);
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },

        changeState: function(item) {
            this.$store.state.isLoading = true;
            var str = this.$store;
            var params = {
                Active: item.Active
            };
            console.log(params);
            axios
                .put('bookedoff-cause/' + item.BookedCauseID, params)
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    console.log(response.data);
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Booked Off Cause status changed.'
                    });
                    this.loadCauses();
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        report: function() {
            var str = this.$store;
            if (this.type.id == null) {
                str.dispatch('setSnackbar', {
                    color: 'red',
                    text: 'Select a Type Report'
                });
            } else {
                str.state.isLoading = true;
                axios
                    .post('bookedoff-cause/report', this.type, {
                        responseType: 'blob',
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        const url = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        var fileName =
                            this.type.text +
                            ' ' +
                            this.type.TypeReport +
                            '.xlsx';
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', fileName);
                        console.log(this.startDate);
                        document.body.appendChild(link);
                        link.click();
                        str.state.isLoading = false;
                    })
                    .catch(function(error) {
                        console.log(error);
                        str.state.isLoading = false;
                    });
            }
        }
    }
};
</script>
